import { ScrollTrigger } from "@gsap";

const STORAGE_KEY = "pk-text-scale";
const root = document.documentElement;

const steps = () =>
	getComputedStyle(root)
		.getPropertyValue("--pk-text-scale-steps")
		.replace(/["']/g, "")
		.split(",")
		.map((step) => parseFloat(step))
		.filter((step) => !Number.isNaN(step));

const current = () => parseFloat(getComputedStyle(root).getPropertyValue("--pk-text-scale")) || 1;

const save = (scale) => {
	try {
		localStorage.setItem(STORAGE_KEY, String(scale));
	} catch (e) {}
};

const sync = (toggles, scale, levels) => {
	const level = Math.max(levels.indexOf(scale), 0);
	toggles.forEach((toggle) => {
		toggle.setAttribute("aria-pressed", String(level > 0));
		toggle.dataset.textScaleLevel = String(level);
	});
};

function initTextScale() {
	const toggles = document.querySelectorAll("[data-text-scale-toggle]");
	const levels = steps();
	if (!toggles.length || !levels.length) return;

	sync(toggles, current(), levels);

	toggles.forEach((toggle) =>
		toggle.addEventListener("click", () => {
			const index = levels.indexOf(current());
			const next = levels[(index + 1) % levels.length];
			root.style.setProperty("--pk-text-scale", next);
			save(next);
			sync(toggles, next, levels);
			ScrollTrigger.refresh();
		})
	);
}

if (document.readyState === "loading") {
	document.addEventListener("DOMContentLoaded", initTextScale);
} else {
	initTextScale();
}
